<template>
  <div id="app">
     <myHead title="管理中心"></myHead>
     <div class="page">
        <div class="page-content">
          <img src="../../assets/img/center-lo@2x.png"  alt="">
          <p>以下是你已开通的聊天号</p>
        </div>
        <centerUserList v-if="flag" ></centerUserList>
     </div>  
  </div>
</template>
<script>
import myHead from "../common/head";
import centerInfo from "../common/centerInfo";
import centerUserList from "../common/centerUserListpw";

import {mapGetters} from 'vuex'
//接口地址
import api from "../../api/index";
//toast组件
import tips from "@/estoast";
import util from "@/utils/util";
import store from "@/store";
import * as types from "../../store/types";

export default {
  metaInfo: {
    title:"管理中心",
  },
  name: "app",
  data() {
    return {
      msg: "管理中心",
      userInfo:null,
      users:null,
      flag:true
    };
  }, 
  mounted: function() {
    this.$point.init(new Date());
    store.dispatch('hideLoading');    
    var token = this.getToken;
    console.log("store里面的toekn有值" + JSON.stringify(token));
    if (token == null || token == "") {
      token = localStorage.getItem("token");
      console.log("localStorage缓存token：" + token);
      store.commit(types.LOGIN, token);
    }
    if (token == "" || token == null) {
        this.$router.push("/login");
    }
    this.userInfo = this.users;

},
methods:{

      //初始化weosocket
    initWebSocket() {
      if (typeof WebSocket === "undefined") {
        alert("您的浏览器不支持WebSocket");
        return false;
      }
      const wsuri =
        "ws://47.112.204.13:8091/imserver/" +
        this.userId +
        "/" +
        this.socketToken; // websocket地址

      console.log("socket url:" + wsuri);

      this.websock = new WebSocket(wsuri);
      this.websock.onopen = this.websocketonopen;
      this.websock.onmessage = this.websocketonmessage;
      this.websock.onerror = this.websocketonerror;
      this.websock.onclose = this.websocketclose;
    },
    //连接成功
    websocketonopen() {
      console.log("WebSocket连接成功");
    },
    //接收后端返回的数据
    websocketonmessage(e) {
      let dataJson = JSON.parse(e.data);
      console.log("相应数据"+JSON.stringify(e.data));
      // 在这里使用后端返回的数据，对数据进行处理渲染
    },
    //连接建立失败重连
    websocketonerror(e) {
      console.log(`连接失败的信息：`, e);
      this.initWebSocket(); // 连接失败后尝试重新连接
    },
    //关闭连接
    websocketclose(e) {
      console.log("断开连接", e);
    },
    websocketsend(agentData) {
      //数据发送
      this.websock.send(agentData);
    },
    changeUserInfo: function() {
      this.$axiosHttp({
        method: "POST",
        url: api.qml.getuserInfo,
        data: { flag: 1 }
      })
        .then(res => {
          if (res.code == 0) {
            this.userInfo =  res.result;
            //将对应的数据保存到Vuex中
            console.log("有效期："+ res.result.validitydate);
            console.log("有效期："+ res.result.viptype);

            store.commit(types.SET_USERINFO, res.result);
            store.commit(types.SET_USERLIST, res.result.userRelList);
            this.flag=true
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
    }
},
beforeCreate(){

  var token = this.getToken;
  console.log("本地缓存token："+token)
  if(token == null || token == null){
     token = localStorage.getItem('token');
     console.log("localStorage缓存token："+token)
    store.commit(types.LOGIN, token);
  }

 

  console.log("页面加载开始");
   this.$axiosHttp({
        method: "POST",
        url: api.qml.getuserInfo,
        data: { flag: 1 }
      })
        .then(res => {
          if (res.code == 0) {
            this.userInfo =  res.result;
            //将对应的数据保存到Vuex中
            console.log("有效期："+ res.result.validitydate);
            console.log("有效期："+ res.result.viptype);

            store.commit(types.SET_USERINFO, res.result);
            store.commit(types.SET_USERLIST, res.result.userRelList);
            this.flag=true;
          } else {
            tips.toast(res.message);
          }
        })
        .catch(err => {
          tips.toast(err);
          console.log(err);
        });
},
created() {
    var user = this.getUserInfo;
    this.userId = user.id;
    this.socketToken = this.getSToken;

    if (this.websock) {
      this.websock.close(); // 关闭websocket连接
    }
    this.initWebSocket();
    
  },
  destroyed() {
    //页面销毁时关闭ws连接
    if (this.websock) {
      this.websock.close(); // 关闭websocket
    }
  },
  computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList",
      "getSToken"
    ])
  },
  components: {
    myHead,centerInfo,centerUserList
  }
};
</script>
<style  scoped>

.page {
  width: 750px;
  min-height: 1344px;
  background-image: url('../../assets/img/background@2x.png');
  padding: 28px 0px 40px 0px;
  background-size: cover; 
  height: auto;
}

.page-content{
  width:514px;
  height:88px;
  margin:46px auto;
}
.page-content img{
  width: 100%;
  height: 10px;
}

.page-content p{
  height:88px;
  font-size:28px;
  font-family:PingFangSC-Regular,PingFang SC;
  font-weight:400;
  color:rgba(245,195,167,1);
  line-height:40px;
  position: relative ;
  top:-61px;
}


</style>


// WEBPACK FOOTER //
// src/components/page/userCenterspw.vue